import * as React from "react"
import styled from "styled-components"
import { Spacer } from "../spacers"

interface ButtonProps {
  title: string
  onClick?: () => void
  icon?: React.ReactNode
  color?: string
}

const LinkStyle = styled.div<{ color?: string }>`
  font-size: 18px;
  font-weight: 500;
  color: ${(props) => (props.color ? props.color : props.theme.colors.greyDark)};
  cursor: pointer;
  display: flex;
  align-items: center;

  :hover {
    color: ${(props) => props.theme.colors.greyDarker};
  }
`

const HoverLinkText: React.FunctionComponent<ButtonProps> = ({ title, onClick, icon, color }) => {
  return (
    <>
      <LinkStyle onClick={onClick} color={color}>
        {title}
        {icon && (
          <>
            <Spacer spacing={1} />
            {icon}
          </>
        )}
      </LinkStyle>
    </>
  )
}

export default HoverLinkText
